import { SocketEvent } from '@/services/ws/core/event'
import { EVENTS_ENUM } from '../events'

class UserUpdatedEvent extends SocketEvent {
  async handle(data, { store }) {
    const {
      is_email_verified,
      is_phone_verified,
      is_selfie_verified,
      is_passport_verified,
      verification_status, // 3 - old verif not full, 4 - old verif full
    } = data.payload

    await store.dispatch('user/act_setUserVefificationData', {
      is_email_verified,
      is_phone_verified,
      is_selfie_verified,
      is_passport_verified,
      verification_status,
    })

    window.$nuxt.$emit(EVENTS_ENUM.USER_UPDATED)
  }
}

export const userUpdatedEvent = new UserUpdatedEvent()
